import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Col, Form } from 'react-bootstrap';
import { Shapes } from '../../models/entities';

class CardForm extends PureComponent {
  constructor(props) {
    super(props);

    const { card } = props;
    if (card) {
      this.state = { ...card, isContactInfoSameAsBilling: false };
    } else {
      this.state = {
        isContactInfoSameAsBilling: false,
        alias: '',
        active: true,
        cardNumber: '',
        cardCvv: '',
        cardMonth: '',
        cardYear: '',
        firstName: '',
        lastName: '',
        phoneNumber: '',
        countryCode: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        stateCode: '',
        postalCode: '',
        contactInfo: {
          addressLine1: '', 
          addressLine2: '', 
          city: '', 
          countryCode: '', 
          email: '',
          id: '', 
          phoneNumber: '', 
          postalCode: '', 
          stateCode: '', 
          firstName: '', 
          lastName: '',
        },
        validated: false,
      };
    }
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.updateContactInfoState = this.updateContactInfoState.bind(this);
  }

  updateContactInfoState = (option, value) => {
    this.setState({
    contactInfo: {
      ...this.state.contactInfo,
      [option]: value
    }})
  }

  handleFieldChange = (event) => {
    switch (event.target.id) {
      case 'isContactInfoSameAsBilling': return (this.setState({ isContactInfoSameAsBilling: event.target.checked }));
      case 'active': return (this.setState({ active: event.target.checked }));
      case 'alias': return (this.setState({ alias: event.target.value }));
      case 'cardNumber': return (this.setState({ cardNumber: event.target.value }));
      case 'cardCvv': return (this.setState({ cardCvv: event.target.value }));
      case 'cardMonth': return (this.setState({ cardMonth: event.target.value }));
      case 'cardYear': return (this.setState({ cardYear: event.target.value }));
      case 'firstName': return (this.setState({ firstName: event.target.value }));
      case 'lastName': return (this.setState({ lastName: event.target.value }));
      case 'phoneNumber': return (this.setState({ phoneNumber: event.target.value }));
      case 'countryCode': return (this.setState({ countryCode: event.target.value }));
      case 'addressLine1': return (this.setState({ addressLine1: event.target.value }));
      case 'addressLine2': return (this.setState({ addressLine2: event.target.value }));
      case 'city': return (this.setState({ city: event.target.value }));
      case 'stateCode': return (this.setState({ stateCode: event.target.value }));
      case 'postalCode': return (this.setState({ postalCode: event.target.value }));
      case 'contactFirstName':return  this.updateContactInfoState('firstName', event.target.value);
      case 'contactLastName': return this.updateContactInfoState('lastName', event.target.value);
      case 'contactAddressLine1':return  this.updateContactInfoState('addressLine1', event.target.value);
      case 'contactAddressLine2': return this.updateContactInfoState('addressLine2', event.target.value);
      case 'contactPhoneNumber': return this.updateContactInfoState('phoneNumber', event.target.value);
      case 'contactCountryCode': return this.updateContactInfoState('countryCode', event.target.value);
      case 'contactCity': return this.updateContactInfoState('city', event.target.value);
      case 'contactStateCode': return this.updateContactInfoState('stateCode', event.target.value);
      case 'contactPostalCode': return this.updateContactInfoState('postalCode', event.target.value);
      case 'contactEmail': return this.updateContactInfoState('email', event.target.value);
      default: return this.state;
    }
  }

  handleSubmit = (event) => {
    const { onSubmit } = this.props;

    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    if (form.checkValidity() === true) {

      const body = (({
        isContactInfoSameAsBilling, active, alias, cardNumber, cardCvv, cardMonth, cardYear, firstName, lastName, phoneNumber, countryCode, addressLine1, addressLine2, city, stateCode, postalCode, contactInfo,
      }) => ({
        active, alias, cardNumber, cardCvv, cardMonth, cardYear, firstName, lastName, phoneNumber, countryCode, addressLine1, addressLine2, city, stateCode, postalCode,
        contactInfo: (isContactInfoSameAsBilling) ? { addressLine1, addressLine2, city, countryCode, email: contactInfo.email, id: contactInfo.id, phoneNumber, postalCode, stateCode, firstName, lastName } : contactInfo,
      }))(this.state);
      onSubmit(body);
    }
    this.setState({ validated: true });
  }

  render = () => {
    const {
      isContactInfoSameAsBilling, active, alias, cardNumber, cardCvv, cardMonth, cardYear, firstName, lastName, phoneNumber, countryCode, addressLine1, addressLine2, city, stateCode, postalCode, contactInfo, validated, 
    } = this.state;

    const { formId, disabled } = this.props;

    return (
      <Form noValidate validated={validated} onSubmit={this.handleSubmit} id={formId}>
        <Form.Row>
          <Col>
            <Form.Group controlId="active">
              <Form.Check
                checked={active}
                type="checkbox"
                onChange={this.handleFieldChange}
                value={active}
                label="Is this credit card active?"
              />
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group controlId="alias">
              <Form.Label>Alias</Form.Label>
              <Form.Control
                disabled={disabled}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={alias}
                placeholder="alias - nickname"
              />
              <Form.Control.Feedback type="invalid">
                Please provide a nickname for this card.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="cardNumber">
              <Form.Label>Card Number</Form.Label>
              <Form.Control
                disabled={disabled}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={cardNumber}
                placeholder="cardNumber"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the card number.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col sm={2}>
            <Form.Group controlId="cardCvv">
              <Form.Label>Card CVV</Form.Label>
              <Form.Control
                disabled={disabled}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={cardCvv}
                placeholder="cardCvv"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the card CVV.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col sm={2}>
            <Form.Group controlId="cardMonth">
              <Form.Label>Card Month</Form.Label>
              <Form.Control
                disabled={disabled}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={cardMonth}
                placeholder="cardMonth"
              />
              <Form.Control.Feedback type="invalid">
                Please provide a phone number.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col sm={2}>
            <Form.Group controlId="cardYear">
              <Form.Label>Card Year</Form.Label>
              <Form.Control
                disabled={disabled}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={cardYear}
                placeholder="cardYear"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the card expiration year.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group controlId="firstName">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                disabled={disabled}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={firstName}
                placeholder="first name"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the first name.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="lastName">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                disabled={disabled}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={lastName}
                placeholder="last name"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the last name.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col sm={2}>
            <Form.Group controlId="phoneNumber">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                disabled={disabled}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={phoneNumber}
                placeholder="phoneNumber"
              />
              <Form.Control.Feedback type="invalid">
                Please provide a phone number.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col sm={2}>
            <Form.Group controlId="countryCode">
              <Form.Label>Country Code</Form.Label>
              <Form.Control
                disabled={disabled}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={countryCode}
                placeholder="countryCode"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the country code.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group controlId="addressLine1">
              <Form.Label>Address Line1</Form.Label>
              <Form.Control
                disabled={disabled}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={addressLine1}
                placeholder="address line1"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the address line1.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="addressLine2">
              <Form.Label>Address Line2</Form.Label>
              <Form.Control
                disabled={disabled}
                type="text"
                onChange={this.handleFieldChange}
                value={addressLine2 || '-'}
                placeholder="address line2"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the address line2.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group controlId="city">
              <Form.Label>City</Form.Label>
              <Form.Control
                disabled={disabled}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={city}
                placeholder="city"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the city.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col sm={2}>
            <Form.Group controlId="stateCode">
              <Form.Label>State Code</Form.Label>
              <Form.Control
                disabled={disabled}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={stateCode}
                placeholder="stateCode"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the state code (abbreviation).
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col sm={2}>
            <Form.Group controlId="postalCode">
              <Form.Label>Postal Zip Code</Form.Label>
              <Form.Control
                disabled={disabled}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={postalCode}
                placeholder="postalCode"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the zip code.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
        {disabled ? null : ( 
          <Col>
            <Form.Group controlId="isContactInfoSameAsBilling">
              <Form.Check
                checked={isContactInfoSameAsBilling}
                type="checkbox"
                onChange={this.handleFieldChange}
                value={isContactInfoSameAsBilling}
                label="Is Contact Info the same as billing?"
              />
            </Form.Group>
          </Col>
        )}
          <Col>
            <Form.Group controlId="contactEmail">
              <Form.Label>Contact Email</Form.Label>
              <Form.Control
                disabled={disabled}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={contactInfo.email}
                placeholder="email"
              />
              <Form.Control.Feedback type="invalid">
                Please provide an email address.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Form.Row>
        {(!disabled && isContactInfoSameAsBilling) ? null : (
        <Form.Row>
          <Col>
            <Form.Group controlId="contactFirstName">
              <Form.Label>Contact Info: First Name</Form.Label>
              <Form.Control
                disabled={disabled}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={contactInfo.firstName}
                placeholder="first name"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the first name.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="contactLastName">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                disabled={disabled}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={contactInfo.lastName}
                placeholder="last name"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the last name.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col sm={2}>
            <Form.Group controlId="contactPhoneNumber">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                disabled={disabled}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={contactInfo.phoneNumber}
                placeholder="phoneNumber"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the card expiration month.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col sm={2}>
            <Form.Group controlId="contactCountryCode">
              <Form.Label>Country Code</Form.Label>
              <Form.Control
                disabled={disabled}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={contactInfo.countryCode}
                placeholder="countryCode"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the country code.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Form.Row>
        )}
        {(!disabled && isContactInfoSameAsBilling) ? null : (
        <Form.Row>
          <Col>
            <Form.Group controlId="contactAddressLine1">
              <Form.Label>Contact Info: Address Line1</Form.Label>
              <Form.Control
                disabled={disabled}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={contactInfo.addressLine1}
                placeholder="address line1"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the address line1.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="contactAddressLine2">
              <Form.Label>Address Line2</Form.Label>
              <Form.Control
                disabled={disabled}
                type="text"
                onChange={this.handleFieldChange}
                value={contactInfo.addressLine2 || '-'}
                placeholder="address line2"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the address line2.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Form.Row>
        )}
        {(!disabled && isContactInfoSameAsBilling) ? null : (
        <Form.Row>
          <Col>
            <Form.Group controlId="contactCity">
              <Form.Label>Contact Info: City</Form.Label>
              <Form.Control
                disabled={disabled}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={contactInfo.city}
                placeholder="city"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the city.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col sm={2}>
            <Form.Group controlId="contactStateCode">
              <Form.Label>State Code</Form.Label>
              <Form.Control
                disabled={disabled}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={contactInfo.stateCode}
                placeholder="state"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the state code (abbreviation).
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col sm={2}>
            <Form.Group controlId="contactPostalCode">
              <Form.Label>Postal Zip Code</Form.Label>
              <Form.Control
                disabled={disabled}
                required
                type="text"
                onChange={this.handleFieldChange}
                value={contactInfo.postalCode}
                placeholder="postalCode"
              />
              <Form.Control.Feedback type="invalid">
                Please provide the zip code.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Form.Row>
        )}
      </Form>
    );
  }
}

CardForm.propTypes = {
  onSubmit: PropTypes.func,
  formId: PropTypes.string.isRequired,
  card: Shapes.CARD,
  disabled: PropTypes.bool,
};

CardForm.defaultProps = {
  card: null,
  onSubmit: undefined,
  disabled: false,
};

export default CardForm;
